import { Button, Typography } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';


// COMPONENT
import { RouteImage } from '../../../../../assets/routeImage';
import TableCustom from '../../../../../component/table/tableCustom';
import TableRowCommon from '../../../../../component/table/TableRowCommon';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { FilesApi } from '../../../../../api/files/files.api';
import TrackingDrageAndDrop from '../../../../../component/dragAndDrop/TrackingDrageAndDrop';
import { swalError } from '../../../../../component/notification/swal';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice';
import Loading from '../../../../../component/loading/Loading';

type Props = {
    projectTracking: any;
    updateTrackingProject: (data: any, mainIndex: number) => void;
    deleteFileTracking: (mainIndex: number, detailIndex: number) => void;
    index: number;
}

const FileTracking: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);

    const headCells = [
        {
            id: "RANK", disablePadding: false, align: 'center', label: "ลำดับ"
        },
        {
            id: "file_name", width: 500, disablePadding: false, align: "center", label: "ชื่อเอกสารแนบ"
        },
        {
            id: "file_type", disablePadding: false, align: "center", label: "สกุลไฟล์"

        },
        {
            id: "fileSize", disablePadding: false, align: "center", width: 140, label: "ขนาด"

        },
        {
            id: "SUBCATEGORIES", disablePadding: false, width: 100, align: "right", label: ""
        },
    ];

    const renderData = (objData: any, no: any) => {
        // no = page * pageLimit - pageLimit + no + 1
        const { id, name, fileType, type, size, idFile, fileName, fileSize } =
            objData;

        const objRenderData = {
            key: id,
            id: id || idFile,
            obj: objData,
            columns: [
                {
                    option: "TEXT", align: "center", label: no + 1
                },
                {
                    option: "TEXT", align: "left", label: name || fileName,
                },
                {
                    option: "TEXT", align: "left", label: type || fileType,
                },
                {
                    option: "TEXT", align: "center", label: `${Number(size || fileSize / 1024).toFixed(2)} kb`,
                },
                {
                    option: "TEXT",
                    align: "right",
                    width: 100,
                    label:
                        <span className='flex items-center gap-x-8'>
                            <div onClick={() => handleGetFile(idFile, fileType, objData)} className='flex gap-1 cursor-pointer'>
                                <RemoveRedEyeOutlinedIcon className='text-base_disable cursor-pointer' />
                                <Typography>{t("ดู")}</Typography>
                            </div>
                            <div onClick={() => handleDeleteFile(no)} className='flex cursor-pointer gap-1'>
                                <img src={RouteImage.delete} style={{ maxWidth: 24 }} alt='icons' />
                                <Typography>{t("ลบ")}</Typography>
                            </div>
                        </span>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteFile = (detailIndex: number) => {
        props.deleteFileTracking(props.index, detailIndex)
    }

    const handleGetFile = async (idFile: number, fileType: string, objData?: any) => {
        if (idFile) {
            dispatch(setLoading())
            await FilesApi.getFile(idFile)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        const blob = new Blob([res.data], { type: fileType },);
                        const url = window.URL.createObjectURL(blob)
                        window.open(url, '_blank');
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
        } else {
            const url = window.URL.createObjectURL(objData)
            window.open(url, '_blank');
        }
    }

    const handleAddFile = (data: any) => {
        props.updateTrackingProject([...data], props.index)

    }

    // console.log(allFile)

    return (
        <div className='w-full mt-8'>
            {isLoading === true && <Loading />}
            <span>
                <Typography className='text-primary' variant='h5'>
                    {t("เอกสาร")}
                </Typography>
            </span>
            <section className='w-full mt-3'>
                <TableCustom
                    page={1}
                    pageLimit={5}
                    sortBy=""
                    sortType="ASC"
                    headCells={headCells}
                    rowCount={25}
                    rowsData={props.projectTracking && props.projectTracking?.projectTrack?.detailFiles?.map((data: any, i: any) => {
                        return renderData(data, i)
                    }) || []}
                    onSort={() => { }}
                    setPageLimit={(value: number) => { }}
                    setPage={(value: number) => { }}
                    hidePagination
                />
            </section>
            <section className='mt-5'>
                <TrackingDrageAndDrop
                    required={props.projectTracking?.projectTrack?.detailFiles?.length === 0}
                    onTypeError={(error) => swalError(error)}
                    onSizeError={(error) => swalError(error)}
                    fileType={['JPG', 'JPEG', 'GIF', 'PNG', 'PDF', 'WORD', 'EXCEL', 'XLSX']}
                    multiple
                    fileId={0}
                    maxSize={10}
                    onUpload={(data) => handleAddFile(data)}
                />
            </section>
        </div>
    )
}

export default FileTracking